import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatNumber(num) {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  return num.toString();
}

export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function getScoreColor(score) {
  if (score >= 90) return 'text-success';
  if (score >= 75) return 'text-info';
  if (score >= 60) return 'text-warning';
  if (score >= 40) return 'text-orange-500';
  return 'text-destructive';
}

export function getScoreLabel(score) {
  if (score >= 90) return 'EXCELENTE';
  if (score >= 75) return 'BOM';
  if (score >= 60) return 'REGULAR';
  if (score >= 40) return 'INSUFICIENTE';
  return 'CRÍTICO';
}

export function getSeverityColor(severity) {
  const colors = {
    critical: 'bg-destructive/20 text-destructive border-destructive/30',
    high: 'bg-orange-500/20 text-orange-500 border-orange-500/30',
    medium: 'bg-warning/20 text-warning border-warning/30',
    low: 'bg-info/20 text-info border-info/30',
    info: 'bg-muted text-muted-foreground border-border',
  };
  return colors[severity] || colors.info;
}

export function getStatusColor(status) {
  const colors = {
    online: 'bg-success',
    offline: 'bg-destructive',
    warning: 'bg-warning',
    critical: 'bg-destructive animate-pulse',
  };
  return colors[status] || 'bg-muted';
}
